// 活动
export default [
    {
        path: "/activity/list",
        name: "activityList",
        component: () => import("../views/activity/index.vue"),
    },
    {
        path: "/activity/detail",
        name: "activityDetail",
        component: () => import("../views/activity/detail.vue"),
    },
    {
        path: "/activity/specialDetail",
        name: "specialDetail",
        component: () => import("../views/activity/specialDetail.vue"),
    },
    //好老师临时活动
    {
        path: "/activity/specialDetail2",
        name: "specialDetail2",
        component: () => import("../views/activity/specialDetail2.vue"),
    },
    //第三届青年教师教研成果研讨展示交流活动临时活动
    {
        path: "/activity/specialDetail3",
        name: "specialDetail3",
        component: () => import("../views/activity/specialDetail3.vue"),
    },
    //小先生临时活动
    {
        path: "/activity/specialDetail4",
        name: "specialDetail4",
        component: () => import("../views/activity/specialDetail4.vue"),
    },
    //大先生临时活动
    {
        path: "/activity/specialDetail5",
        name: "specialDetail5",
        component: () => import("../views/activity/specialDetail5.vue"),
    },
    //新重庆临时活动
    {
        path: "/activity/specialDetail6",
        name: "specialDetail6",
        component: () => import("../views/activity/specialDetail6.vue"),
    },
    //放下手机活动
    {
        path: "/activity/specialDetail7",
        name: "specialDetail7",
        component: () => import("../views/activity/specialDetail7.vue"),
    },
    // 新大小先生活动
    {
        path: "/activity/specialDetail8",
        name: "specialDetail8",
        component: () => import("../views/activity/specialDetail8.vue"),
    },
]